export default class CheckBoxEvent<Item> extends Event {
	/**
	 * The static SELECTED_CHANGED type is dispatched when the CheckBox is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(CheckBoxEvent.SELECTED_CHANGED, (event: CheckBoxEvent) => {});
	 */
	public static SELECTED_CHANGED = 'CheckBoxEvent.selectedChanged';

	/** The item property of the CheckBox will be sent along with the CheckBoxEvent as this item property. */
	public get item(): Item | null {
		return this.#item;
	}

	/** The selected property reflects the selected property of the CheckBox after it changed the selected value. */
	public get selected(): boolean {
		return this.#selected;
	}

	#item: Item | null;
	#selected: boolean;
	public constructor(selected: boolean, item: Item | null = null) {
		super(CheckBoxEvent.SELECTED_CHANGED, { bubbles: true });
		this.#selected = selected;
		this.#item = item;
	}
}
